
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Dismiss from '@/components/Dismiss.vue';
import moment from 'moment';

@Component({
  components: {
    Dismiss,
  },
})
export default class ResumeSubscription extends Vue {
  @Prop(Boolean)
  open!: boolean;

  @Prop()
  subscriptionEnd!: moment.Moment;

  step = 1;

  get currentTitle() {
    switch (this.step) {
      case 1:
        return 'Ready to resume your subscription?';
      default:
        return 'Let’s get those QR Codes working again';
    }
  }

  cancel() {
    this.$emit('cancel');

    setTimeout(() => {
      this.step = 1;
    }, 500);
  }

  @Watch('open')
  onOpenChange(open: boolean) {
    if (!open) {
      return;
    }
  }
}
